/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';

export const solutionCardCss = css({
  border: `1px solid rgba(213, 208, 196, 0.5)`,
  borderBottomLeftRadius: 40,
  color: colorsPalette.black,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: 320,
  padding: '16px 16px 24px',
  textDecoration: 'none',
  width: 327,
  [MediaQueries.lg]: {
    minWidth: 347,
    width: 'auto',
  },
  [MediaQueries.lgAndUp]: {
    padding: '32px 32px 24px',
    minHeight: 457,
  },
  [MediaQueries.xl]: {
    width: 359,
  },
});

export const solutionCardAsLinkCss = css({
  '&:visited': {
    textDecoration: 'none',
  },
  '&:hover': {
    borderColor: colorsPalette.transparent,
    boxShadow: shadows.shadow80,
    outline: 0,
  },
});

export const buttonCss = isClickeable =>
  css({
    textAlign: 'left',
    cursor: isClickeable && 'pointer',
  });

export const darkCardCss = css({
  backgroundColor: colorsPalette.black,
  color: colorsPalette.white,
});
